import { useMutation } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { DeathsAndDiseasesController } from 'src/controllers/deaths-and-diseases.controller'
import { UpdateDeathsAndDiseasesDto } from 'src/dto/deaths-and-diseases.dto'

const deathsAndDiseasesController = new DeathsAndDiseasesController()

export function useUpdateDeathsAndDiseases() {
  const { userFarm: farmId } = useAuth()

  return useMutation({
    mutationKey: ['updateDeathsAndDiseases'],
    mutationFn: (deathsAndDiseasesDto: UpdateDeathsAndDiseasesDto) =>
      deathsAndDiseasesController.updateDeathsAndDiseases(farmId!, deathsAndDiseasesDto)
  })
}
